import { Severity } from "../../../services/redux/consoleSlice";

export const createLogPayload = (...args: any[]) => {
    // Handle unserializable object
    const handleUnserializableObject = (obj: any): any => {
        if (obj instanceof Error) {
            return {
                message: obj.message,
                name: obj.name,
                stack: obj.stack
            };
        }
        return { description: `Unserializable object encountered. ${typeof (obj)}` };
    };

    // Handle argument for JSON serialization
    const handleArgument = (arg: any): string => {
        try {
            return JSON.stringify(arg);
        } catch (err) {
            return JSON.stringify(handleUnserializableObject(arg));
        }
    };

    // Process the args
    const processedArgs = args.map(arg => handleArgument(arg));
    const message = processedArgs.join("\n");

    return {
        message,
        severity: Severity.Error,
        processedArgs,
    };
};
